import { render } from "./CountrySelectVertical.vue?vue&type=template&id=45e0182f"
import script from "./CountrySelectVertical.vue?vue&type=script&lang=js"
export * from "./CountrySelectVertical.vue?vue&type=script&lang=js"

import exportComponent from "/home/forge/hub.disinfo.eu/releases/81973855/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__